<div class="padleft40px padtop110px colorblue">Submit a Helpdesk Ticket (JIRA)&nbsp;
<button mat-flat-button color="primary" (click)="createTicket()">Create ticket</button>
</div>
